// src/components/layout/SnakeColumns.tsx
import React from "react";

export function makeSnakeColumns<T>(items: T[], cols: number): T[][] {
  const out: T[][] = Array.from({ length: Math.max(1, cols) }, () => []);
  let c = 0;
  for (const it of items) {
    out[c].push(it);
    c = (c + 1) % out.length;
  }
  // Parne kolone obrni da dobijemo meandar (zmiju)
  return out.map((col, i) => (i % 2 === 1 ? [...col].reverse() : col));
}

export function SnakeColumns({
  cols,
  minColWidth,
  gap = 12,
  children,
}: {
  cols: number;
  minColWidth: number;
  gap?: number;
  children: React.ReactNode[];
}) {
  return (
    <div style={{ display: "flex", gap, overflowX: "auto", paddingBottom: 8 }}>
      {Array.from({ length: cols }).map((_, idx) => (
        <div
          key={idx}
          style={{
            display: "flex",
            flexDirection: "column",
            gap,
            minWidth: minColWidth + 20,
          }}
        />
      ))}
      {children}
    </div>
  );
}
